import React from "react";

const MessageContext = React.createContext({
  displaySuccess: () => {},
  displayError: () => {},
});

export default MessageContext;
